import { ConfigStorePartial } from '@spiaggeit/map-canvas/store/configStore'
import { SPIT_DEBUG_SP_KEY } from '@/utils/constants'
import { setupByUrl } from './commonActions'
import { createAppSlice } from './createAppSlice'

type MapConfigSliceState = {
  config: ConfigStorePartial
}

const initialState: MapConfigSliceState = {
  config: {},
}

export const mapConfigSlice = createAppSlice({
  extraReducers(builder) {
    builder.addCase(setupByUrl, (state, action) => {
      const { searchParams } = new URL(action.payload)

      const isDebug = searchParams.get(SPIT_DEBUG_SP_KEY) === '1'
      if (!isDebug) {
        state.config = {}
        return
      }

      state.config = {
        lazyLoadEnabled: searchParams.get('lazy') === '1',
      }

      const cachePixelRatioParam = searchParams.get('cachePixelRatio')
      if (cachePixelRatioParam) {
        const cachePixelRatio = parseFloat(cachePixelRatioParam)
        if (!isNaN(cachePixelRatio)) {
          state.config.cachePixelRation = Math.min(cachePixelRatio, 2)
        }
      }

      const clusterSizeParam = searchParams.get('clusterSize')
      if (clusterSizeParam) {
        const clusterSize = parseInt(clusterSizeParam)
        if (!isNaN(clusterSize)) {
          state.config.clusterSize = clusterSize
        }
      }

      const dragMoveThrottleParam = searchParams.get('dragMoveThrottle')
      if (dragMoveThrottleParam) {
        const dragMoveThrottle = parseInt(dragMoveThrottleParam)
        if (!isNaN(dragMoveThrottle)) {
          state.config.dragMoveThrottle = dragMoveThrottle
        }
      }
    })
  },
  initialState,
  name: 'mapConfig',
  reducers: {},
  selectors: {
    config(state) {
      return state.config
    },
  },
})
